import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ExCircleIconSvg from './icon-ex-circle.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ExCircleIconSvg {...validProps} />;
}
SvgComponent.iconName = 'stop-circleIcon';

/**
 * @deprecated This is a legacy icon
 */
export const ExCircleIcon = svgIconWrapper(SvgComponent);
